<template >
  <tr style="background-color:white">
    <td :rowspan="totalRowSpan" v-if="rowIndex == 0" style="background-color: #f8f9fa" :title="stock.vendor.name.length > 15 ? stock.vendor.name : null">
			<strong>{{ truncateName(stock.vendor.name) }}</strong><span v-if="stock.vendor.id == 21"> (LZ: {{ stock.vendorDeliveryTime }})</span><br>
			<span>{{ stock.articleCondition == 1 ? "Neu" : "Gebraucht" }}</span><br>
			<span>{{ Number(stock.purchasePrice).toFixed(2) }} €</span><br>
			<span>Bestand: {{ stock.quantity }}</span><br>
			<span>LK {{stock.vendor.deliveryClass}}</span><br>

		</td>
    <!-- Land -->
    <td scope="col" v-if='liveListing?.priceInfoHistories?.[0]?.priceState !== 0'>
      <span>{{ liveListing?.marketaccount?.country?.countryIso }}</span>
    </td>

    <!-- Market Account-->
    <td scope="col" v-if='liveListing?.priceInfoHistories?.[0]?.priceState !== 0'>
      <span class="d-flex">
				<a @click="openInNewTab(buildLink(liveListing?.marketaccount?.mdsMarketIdentifier))" onmouseover style="cursor: pointer;">
					<img v-bind:src="'/images/marketicons/' + liveListing?.marketaccount?.market?.id +'.gif'" border="0" width="24" height="24"/>
				</a>
          <b class="ml-2">{{ liveListing?.marketaccount?.market?.name}}</b>
      </span>
    </td>

    <!-- FU -->
    <td scope="col">
      <span v-if="liveListing?.newAsUsed == 1" class="">x</span>
    </td>
    <!-- LSt -->
    <td scope="col">
      <span v-if="!isNegativePriceState()">{{ liveListing?.quantity }}</span>
      <span v-else>—</span>
    </td>
    
    <!-- Seller -->
    <td scope="col">
      <span v-if="isNegativePriceState()">—</span>
      <span v-else-if='liveListing?.priceInfoHistories?.length > 0'>
          <span v-if='liveListing?.priceInfoHistories?.[0] && liveListing?.priceInfoHistories?.[0]?.merchantPrice > 0'>
            <span class="mb-0">{{ Number(liveListing?.priceInfoHistories?.[0]?.merchantPrice).toFixed(2) + ' ' + liveListing.currencySymbol }}</span>
            <span v-if="liveListing.currencyIso != 'EUR'">{{(Number(liveListing.priceInfoHistories[0].merchantPrice)*Number(liveListing?.marketaccount?.country.currencyToEuro)).toFixed(2) + ' €'}}</span>
          </span>
          <span v-else-if='liveListing?.priceInfoHistories?.[1] && liveListing?.priceInfoHistories?.[1]?.merchantPrice > 0'>
            <span class="mb-0">{{ Number(liveListing?.priceInfoHistories?.[1]?.merchantPrice)?.toFixed(2) + ' ' + liveListing?.currencySymbol }}</span>
            <span v-if="liveListing?.currencyIso != 'EUR'">{{(Number(liveListing?.priceInfoHistories?.[1]?.merchantPrice)*Number(liveListing?.marketaccount?.country.currencyToEuro)).toFixed(2) + ' €'}}</span>
          </span>
          <span v-else><span>—</span></span>
      </span>
    </td>
    <!-- New FBA -->
    <td scope="col">
      <span v-if="isNegativePriceState()">—</span>
      <span v-else-if='liveListing?.priceInfoHistories?.length > 0'>
          <span v-if='liveListing?.priceInfoHistories?.[0] && liveListing?.priceInfoHistories?.[0]?.marketPrice > 0'>
            <span class="mb-0">{{Number(liveListing?.priceInfoHistories?.[0].marketPrice).toFixed(2) + ' ' + liveListing.currencySymbol }}</span>
            <span class="mb-0">{{(Number(liveListing.priceInfoHistories?.[0]?.marketPrice) * Number(liveListing?.marketaccount?.country.currencyToEuro)).toFixed(2) + ' €'}}</span>
          </span>
          <span v-else-if="liveListing?.priceInfoHistories?.[1] && liveListing.priceInfoHistories?.[1].marketPrice > 0">
            <span class="mb-0">{{Number(liveListing.priceInfoHistories?.[1]?.marketPrice).toFixed(2) + ' ' + liveListing.currencySymbol }}</span>
            <span class="mb-0">{{(Number(liveListing?.priceInfoHistories?.[1]?.marketPrice) * Number(liveListing?.marketaccount?.country.currencyToEuro)).toFixed(2) + ' €'}}</span>
          </span>
          <span v-else>—</span>
      </span>
      <span v-else>—</span>
    </td>

    <!-- min -->
    <td scope="col" v-if='liveListing.sellingPriceMin == "" || isNegativePriceState()'>—</td>
    <td scope="col" v-else>
      <live-listing-price-calc-log-cmp :live-listing="liveListing" v-if="!isNegativePriceState()" />

      <span v-if="liveListing?.currencyIso != 'EUR'"><br>{{ calcAndFormatPrice(liveListing.sellingPriceMin, ' €', liveListing?.marketaccount?.country.currencyToEuro, liveListing.marketaccount.ownShippingFee)}}</span>
    </td>

    <!-- VK -- Id 11 = Kauflauf - hat autopricing-->
    <td scope="col" v-if="isNegativePriceState() || [11,45,46,47,50,51,52].includes(liveListing.marketaccount.id)">—</td>
    <td scope="col" v-else>
      <span class="mb-0">{{ calcAndFormatPrice(liveListing.sellingPrice, liveListing.currencySymbol, 1, liveListing.marketaccount.ownShippingFee) }}</span>
      <span v-if="liveListing.currencyIso != 'EUR'">
         <br> {{ calcAndFormatPrice(liveListing.sellingPrice, ' €', liveListing?.marketaccount?.country.currencyToEuro, liveListing.marketaccount.ownShippingFee) }}
      </span>
    </td>
    <!-- Max -->
    <td scope="col" v-if='liveListing.sellingPriceMax === ""  || isNegativePriceState()'>—</td>
    <td scope="col" v-else>
      <span class="mb-0">{{ calcAndFormatPrice(liveListing.sellingPriceMax, liveListing.currencySymbol, 1, liveListing.marketaccount.ownShippingFee) }}</span>
      <span v-if='liveListing.currencyIso != "EUR"'><br>{{ calcAndFormatPrice(liveListing.sellingPriceMax, ' €', liveListing?.marketaccount?.country.currencyToEuro, liveListing?.marketaccount?.ownShippingFee)}}</span>
    </td>
    <!-- PriceState -->
    <td>
      <div class="row m-auto" v-bind:style='{ color: liveListing.priceStateStyle }'>
              <live-listing-price-history-cmp :live-listing="liveListing"/>
            <div class="ml-1" v-if='liveListing.priceInfoHistories?.[0]?.marketPrice > liveListing.sellingPriceMin'> ></div>
      </div>
    </td>
  </tr>
</template>

<script>
import LiveListingPriceHistoryCmp from './LiveListingPriceHistoryCmp.vue'
import LiveListingPriceCalcLogCmp from './LiveListingPriceCalcLogCmp.vue'

export default {
  components : {
    LiveListingPriceHistoryCmp,
    LiveListingPriceCalcLogCmp
  },
  props: {
    liveListing : {
      type: Object,
      required: true,
    },
    stock : {
			type: Object,
			required: true,
		},
		totalRowSpan: {
			type: Number,
			default: 1
		},
		rowIndex: {
			type: Number,
			default: 0
		},
		passedAsin: {
			type: String,
			required: true,
		},
		passedEan: {
			type: String,
			required: true,
		},
  },
  data(){
    return {
			marketLinks: {
				"AMZ-AE": "https://www.amazon.ae/",
				"AMZ-AU": "https://www.amazon.com.au/",
				"AMZ-BR": "https://www.amazon.com.br/",
				"AMZ-CA": "https://www.amazon.ca/",
				"AMZ-DE": "https://www.amazon.de/",
				"AMZ-ES": "https://www.amazon.es/",
				"AMZ-FR": "https://www.amazon.fr/",
				"AMZ-IE": "https://www.amazon.ie/",
				"AMZ-IT": "https://www.amazon.it/",
				"AMZ-JP": "https://www.amazon.co.jp/",
				"AMZ-MX": "https://www.amazon.com.mx/",
				"AMZ-NL": "https://www.amazon.nl/",
				"AMZ-BE": "https://www.amazon.com.be/",
				"AMZ-PL": "https://www.amazon.pl/",
				"AMZ-SE": "https://www.amazon.se/",
				"AMZ-SG": "https://www.amazon.sg/",
				"AMZ-TR": "https://www.amazon.com.tr/",
				"AMZ-UK": "https://www.amazon.co.uk/",
				"AMZ-US": "https://www.amazon.com/",
				"BOL-NL": "https://www.bol.com/nl/s/?searchtext=",
				"CDC-FR": "https://www.cdiscount.com/search/10/", //ean.html
				"EPR-IT": "https://www.eprice.it/",
				"FNC-BE": "https://www.fr.fnac.be/SearchResult/ResultList.aspx?Search=", // ean
				"FNC-ES": "https://www.fnac.es/SearchResult/ResultList.aspx?Search=", // ean
				"FNC-FR": "https://www.fnac.com/SearchResult/ResultList.aspx?Search=", // ean
				"FNC-PT": "https://www.fnac.pt/SearchResult/ResultList.aspx?Search=", // ean
				"RAK-FR": "https://fr.shopping.rakuten.com/search/", // ean
				"RDC-FR": "https://www.rueducommerce.fr/",
				"REL-DE": "https://www.kaufland.de/s/?search_value=", //ean
				"WRT-ES": "https://www.worten.es/search?query=", //ean
				"WRT-PT": "https://www.worten.pt/search?query=", //ean
				"ALG-PL": "https://allegro.pl/listing?string=", //ean
				"WAL-US":"https://www.walmart.com/search?q=" // ean
			},
    }
  },
  methods:{
    isNegativePriceState(){
      return (this.liveListing.priceInfoHistories?.[0]?.priceState == -1 ||
              this.liveListing.priceInfoHistories?.[0]?.priceState == -3)
    },
    calcAndFormatPrice(price, currencySymbol, conversionRate = 1, ownShippingFee = 0) {
    	if(ownShippingFee == null) ownShippingFee = 0;

			return Number((Number(price) + Number(ownShippingFee)) * Number(conversionRate)).toFixed(2) + ' ' + currencySymbol;
		},
		truncateName(name) {
			return name.length > 15 ? name.substring(0, 15) + '...' : name;
		},
		openInNewTab(url) {
			const win = window.open(url, "_blank");
			win.focus();
		},
		buildLink(marketIdentifier) {
			switch(marketIdentifier.substring(0, 3))
			{
				case "BOL": return this.marketLinks[marketIdentifier] + this.passedEan;
				case "AMZ": return this.marketLinks[marketIdentifier] + 'dp/' + this.passedAsin;
				case "FNC":
				case "WRT":
				case "RAK":
				case "REL": return this.marketLinks[marketIdentifier] + this.passedEan;
				case "CDC": return this.marketLinks[marketIdentifier] + this.passedEan + ".html";
				case "ALG": return this.marketLinks[marketIdentifier] + this.passedEan;
				case "WAL": return this.marketLinks[marketIdentifier] + this.passedEan;
				default:    return this.marketLinks[marketIdentifier] + this.passedAsin;
			}
		},
  }



}
</script>
